import React from 'react'
import { IonHeader, IonPage, IonToolbar, IonButtons, IonButton, IonIcon, IonTitle } from '@ionic/react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { setSelectedOption } from '../store/initialAssessment.actions'
import { InitialAssessmentConstants } from '../store/initialAssessment.constants'
import { chevronBackOutline } from 'ionicons/icons'
import './InitialAssessment.page.css'
import AddAssessmentInfo from '../addInitialAssessmentInfo/AddInitialAssessmentInfo.component'
import InitialAssessmentMobile from '../initialAssessmentsMobile/InitialAssessmentsMobile.component'
import useDeviceMetrics from '../../../utilities/useDeviceMetrics'

const InitialAssessment: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const history = useHistory()
  const { isTablet } = useDeviceMetrics()
  const onBackClick = () => {
    dispatch(setSelectedOption(InitialAssessmentConstants.NEURO))
    history.push(TabConstants.CHART_ROUTE)
  }

  return (
    <IonPage id='InitialAssessmentPage'>
      <PCRHeader />
      <IonHeader className='ion-no-padding on-landscape-hide'>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton color='primary-alt' data-testid='BackButton' onClick={onBackClick}>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle>{t('fullChart.patient.initialAssessment.InitialAssessment')}</IonTitle>
        </IonToolbar>
        {!isTablet && <InitialAssessmentMobile />}
      </IonHeader>
      <AddAssessmentInfo />
    </IonPage>
  )
}
export default InitialAssessment
